/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_GroupsInputs */

const en_task_flow_groups = /** @type {(inputs: Task_Flow_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups`)
};

const pt_br2_task_flow_groups = /** @type {(inputs: Task_Flow_GroupsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos`)
};

/**
* | output |
* | --- |
* | "Groups" |
*
* @param {Task_Flow_GroupsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_groups = /** @type {((inputs?: Task_Flow_GroupsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_GroupsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_groups(inputs)
	return pt_br2_task_flow_groups(inputs)
});